import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M57.66 107.24c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51-28.166 0-51 22.834-51 51 0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M106.5 46a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m42.94 100.21 3.94-3.93c.59-.59.59-1.54 0-2.12a1.5 1.5 0 0 0-2.12 0l-3.94 3.94-3.94-3.94c-.59-.58-1.54-.58-2.12 0a1.5 1.5 0 0 0 0 2.12l3.94 3.93-3.94 3.93a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44a1.5 1.5 0 0 0 0-2.12zM17.5 25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M100.29 18.27h-5.56v-5.56c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.56h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.56c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M39 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M11.55 71.84c0-28.45 20.32-51.51 45.38-51.51s45.38 23.06 45.38 51.51"
    />
    <path
      fill="#0597A3"
      d="M66.74 70.33c0 5.5-4.42 10-9.81 10s-9.81-4.5-9.81-10V23.87c0-5.5 4.42-10 9.81-10s9.81 4.5 9.81 10z"
    />
    <path
      fill="#0597A3"
      d="M106.63 77.33c0 1.65-1.35 3-3 3h-95c-1.65 0-3-1.35-3-3v-3c0-1.65 1.35-3 3-3h95c1.65 0 3 1.35 3 3zM43.58 60.67c0 2.2-1.52 4-3.37 4s-3.37-1.8-3.37-4V24.46c0-2.2 1.52-4 3.37-4s3.37 1.8 3.37 4zM77.02 60.67c0 2.2-1.52 4-3.37 4s-3.37-1.8-3.37-4V24.46c0-2.2 1.52-4 3.37-4s3.37 1.8 3.37 4zM101.5 89.09l2.68 12.32c.11.5-.42.88-.86.63l-8.92-5.1c-.18-.1-.4-.1-.58 0l-8.92 5.1c-.44.25-.97-.14-.86-.63l2.68-12.32"
    />
    <path
      fill="#001A43"
      d="M94.1 90.87c8.98 0 16.27-7.28 16.27-16.27s-7.28-16.27-16.27-16.27-16.27 7.28-16.27 16.27c0 8.98 7.29 16.27 16.27 16.27"
    />
    <path
      fill="#00D8D8"
      d="m95.15 65.31 2.46 4.85h4.19c.47-.01.9.27 1.09.7s.08.94-.26 1.27l-3.85 3.78 2.13 4.9c.19.46.07.99-.3 1.32s-.92.38-1.35.13l-5.16-2.9-5.16 2.9c-.43.25-.97.2-1.35-.13-.37-.33-.5-.86-.3-1.32l2.13-4.9-3.85-3.79c-.34-.33-.44-.83-.26-1.27s.61-.72 1.09-.7h4.19l2.46-4.84c.2-.39.61-.63 1.05-.63s.85.24 1.05.63"
    />
  </svg>
);
const SvgEnrichedIconSpecialtyContractorInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSpecialtyContractorInverted);
export default Memo;
